"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * VisiblitySensitiveTimeout
 * Props: callback, duration
 *
 * Pauses on window onblur, resumes on window onfocus.
 * Starts when constructed.
 * Only calls callback once.
 *
 * Public methods: cancel
 */
var VisiblitySensitiveTimeout = /** @class */ (function () {
    function VisiblitySensitiveTimeout(callback, duration) {
        var _this = this;
        this.cancel = function () {
            _this.clearTimeout();
            window.removeEventListener('blur', _this.pause);
            window.removeEventListener('focus', _this.resume);
        };
        this.clearTimeout = function () {
            if (_this.timeout) {
                window.clearTimeout(_this.timeout);
            }
        };
        this.pause = function () {
            if (_this.timeout && !_this.paused) {
                _this.paused = true;
                _this.remainingDuration -= Date.now() - _this.startedAt;
                _this.clearTimeout();
            }
        };
        this.resume = function () {
            if (_this.paused) {
                _this.paused = false;
                _this.startedAt = Date.now();
                _this.timeout = setTimeout(function () {
                    _this.callback();
                    _this.timeout = undefined;
                }, _this.remainingDuration);
            }
        };
        this.callback = callback;
        this.remainingDuration = duration;
        this.paused = false;
        this.startedAt = Date.now();
        this.timeout = setTimeout(function () {
            _this.callback();
            _this.timeout = undefined;
        }, this.remainingDuration);
        window.addEventListener('blur', this.pause);
        window.addEventListener('focus', this.resume);
    }
    return VisiblitySensitiveTimeout;
}());
var setVisiblitySensitiveTimeout = function (callback, duration) {
    return new VisiblitySensitiveTimeout(callback, duration);
};
exports.default = setVisiblitySensitiveTimeout;
